import { render } from "./ContributionCmt.vue?vue&type=template&id=4e2064ba&scoped=true"
import script from "./ContributionCmt.vue?vue&type=script&lang=js"
export * from "./ContributionCmt.vue?vue&type=script&lang=js"

import "./ContributionCmt.vue?vue&type=style&index=0&id=4e2064ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2064ba"]])

export default __exports__